module.exports = __webpack_public_path__ + "img/instagram.b6202fff.png";